import {fetching,Loader, changeView} from "../Generals"
import {useEffect,useState} from "react"
import logo from "./../logo.png"

export const Consulta = (props) => {
    let {paramstoload,global,setParamstoload,setLoading,setAlert} = props
    const [cerrar,setCerrar]=useState(null)
    const [link,setLink]=useState(null)
    const [content,setContent]=useState(null)
    const [first,setFirst]=useState(true)
    const [finish,setFinish]=useState(null)

    const loadData = () => {
        let params = {
            userid:paramstoload.userid,
            cursoid:paramstoload.itemid.cursoid,
            itemid:paramstoload.itemid.itemid
        }
        let url=global.domain+"api/v1/consultaData/"+global.apicode+'/'
        fetching(url,params,setContent,null)
    }


    const salirWaitingList = () => {
        let paramsd = {
            userid:paramstoload.userid
        }

        let urld=global.domain+"api/v1/closeOnWaitingList/"+global.apicode

        fetching(urld,paramsd,setCerrar,null)

        setAlert({alert:'Ha salido de la lista de espera',type:'alert-info'})

        if(paramstoload.itemid.itemid === null){
            changeView(2,null,setParamstoload,paramstoload,setLoading)
        }else{
            changeView(13,paramstoload.itemid.cursoid,setParamstoload,paramstoload,setLoading)
        }
    }

    const validateToRedirect = () =>{
        if(paramstoload.itemid !== null){
            setAlert({alert:'La reunión ha finalizado.',type:'alert-info'})
            if(paramstoload.itemid.itemid === null){
                changeView(2,null,setParamstoload,paramstoload,setLoading)
            }else{
                changeView(13,paramstoload.itemid.cursoid,setParamstoload,paramstoload,setLoading)
            }
        }
    }

    const finishmeeting = () => {
        let paramsd = {
            userid:paramstoload.userid
        }
        let urld=global.domain+"api/v1/finishMeeting2/"+global.apicode+'/'
        fetching(urld,paramsd,setFinish,null)
        validateToRedirect()
    }

    const checkStatusMeetingRoom = () => {
        let params = {
            cursoid:paramstoload.itemid.cursoid,
            userid:paramstoload.userid,
            meetingid:content.meetingid

        }
        let url=global.domain+"api/v1/checkStatusMeetingRoom/"+global.apicode+'/'
        fetching(url,params,setLink,null)
    }

    useEffect(loadData,[])

    useEffect(()=>{
        const interval=setInterval(()=>{
            checkStatusMeetingRoom()
        },3500)
        return()=>clearInterval(interval)
    })


    if(content !== null && content.error === 1){
        setAlert({alert:'No tiene sesiones disponibles para consultar.',type:'alert-info'})
        changeView(2,null,setParamstoload,paramstoload,setLoading)
    }


    if(first && link !== null){
        setFirst(false)
        //window.open(link.url, "_blank")
    }

    if( link !== null && link.terminado === true){
        validateToRedirect()
    }


    return <div>
        {content !== null ?
            <>{link === null || link.url === null ?
                <div className="row justify-content-center">
                    <div className="text-center col-lg-8 col-md-9 col-sm-12">
                        {content.profesoresdisponibles > 0 ?
                            <>
                                <i className="fas fa-spinner fa-spin"></i>
                                <div className="alert alert-info">
                                    <p>En un momento le atenderán.</p>
                                    <p className="m-0">Esperando por el próximo profesor disponible. Por favor, no cierre ni cambie de
                                        ventana.</p>
                                </div>
                                <p>Para cancelar su turno en la lista de espera <button className={'link'}
                                onClick={()=>salirWaitingList()}>click aqui</button>.</p>
                                <p className="text-justify">
                                    Si es la primera vez uniéndote a una consulta a través de nuestra plataforma, se te pedirá que
                                    instales la aplicación en tu Computadora. Si no puedes descargar la Aplicación, podrás utilizar la
                                    web App y podrás comenzar la reunión en el mismo explorador.
                                </p>
                                <p className="text-justify">
                                    Si no es la primera vez y ya tienes la aplicación instalada, el programa se abrirá automáticamente
                                    luego de comenzada la reunión.
                                </p>
                                <div id="chat" className="chat"></div>
                            </>
                            :
                            <>
                                <div className="alert alert-warning">
                                    <p className="mb-0">Todos los profesores se encuentran ocupados,
                                sin embargo estas en una lista de espera, en cuanto uno se desocupe te avisaremos. Puedes realizar
                                otras actividades en la plataforma recuerda encender tu sonido pues una campanita te avisará cuando
                                tu profesor este disponible.</p>
                                </div>
                                <p>Para cancelar su turno en la lista de espera
                                <button className={'link'} onClick={()=>salirWaitingList()}>click aqui</button>.</p>
                            </>
                        }
                    </div>
                </div>
                :
                    <div>
                        <div className="row justify-content-center my-5">
                            <div className="col-xl-5 col-6">
                                <div className="card card-people-two">
                                    <div className="card-header">
                                        <div className="pos-absolute a-0">
                                            <img src={logo} alt="Birmingham Institute" />
                                        </div>
                                        <div className="avatar avatar-md">
                                            <div className="bgimgh rounded-circle"
                                                 style={{widht:84, height:84, backgroundImage: 'url('+global.domain+link.profesor.img+')'}}></div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <p className="text-muted">Está siendo atendido por:</p>
                                        <h5 className="card-title ">{link.profesor.nombre}</h5>
                                        <p>El profesor está esperando.</p>
                                        <h5 className="font-weight-light"><a
                                            className="btn btn-primary mt-3" target="_blank" href={link.url}>Entrar
                                            a la asesoría</a>.</h5>
                                        <h5 className="font-weight-light">Ya ha finalizado la reunión? <button
                                            className="link" onClick={()=>finishmeeting()}>Ciérrela aquí.</button>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        :
            <Loader/>}
        </div>
}

